import React, { useEffect } from "react";
import "./Header.css";
import images from "../../../../utilities/images/images";
import { useHistory, useLocation } from "react-router-dom";
import { goBackFromPracticePage } from "../../../../custom_utilities/dashboardBannerNavigation";
import { useDispatch, useSelector } from "react-redux";
import {
  getPyqYearWiseRequest,
  setSelectedPyqYear,
} from "../../../../redux/exam/examSlice";
import { fetchAitsTestListRequest } from "../../../../redux/aits/aitsSlice";
import { getFormatForApi } from "../../../../custom_utilities/pyqFormatUtils";

const Header = () => {
  const navigate = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    pyqYears,
    selectedPyqYear,
    selectedType,
    paperName,
    plannerDetails,
  } = useSelector((state) => state.examSlice);

  const plannerId = plannerDetails?.planner_id;
  const plannerTypeId = plannerDetails?.planner_type_id;
  const paperType = plannerDetails?.id;
  const categoryId = plannerDetails?.category_id;
  const isMistakeBook = String(paperName || "")
    .toLowerCase()
    .includes("mistake book");

  const pyqFormatForApi = getFormatForApi({
    format: selectedType,
    paperName,
    selectedType,
  });

  /* -------- Fetch year list -------- */
  useEffect(() => {
    if (isMistakeBook) return;
    if (plannerDetails?.type === "year wise") {
      dispatch(setSelectedPyqYear(null));
      dispatch(
        getPyqYearWiseRequest(
          pyqFormatForApi ? { topic: pyqFormatForApi } : {}
        )
      );
    }
  }, [dispatch, plannerDetails?.type, pyqFormatForApi, paperName, isMistakeBook]);

  /* -------- Auto select first year -------- */
  useEffect(() => {
    if (isMistakeBook) return;
    if (pyqYears && pyqYears.length > 0) {
      const latestYear = Math.max(...pyqYears.map((y) => Number(y.year)));

      dispatch(setSelectedPyqYear(latestYear));

      dispatch(
        fetchAitsTestListRequest({
          paperType,
          plannerId,
          plannerTestType: plannerTypeId,
          year: latestYear,
          ...(pyqFormatForApi ? { format: pyqFormatForApi } : {}),
          categoryId: categoryId || "",
        })
      );
    }
  }, [pyqYears, isMistakeBook]);
  const handleBackClick = () => {
    // Mistake Book must stay in its own flow — never paper-listing.
    if (isMistakeBook) {
      navigate.push("/practice/mistake-book");
      return;
    }
    goBackFromPracticePage(navigate, location);
  };

  const handleYearChange = (e) => {
    if (isMistakeBook) return;
    const year = e.target.value;
    dispatch(setSelectedPyqYear(year));

    dispatch(
      fetchAitsTestListRequest({
        paperType,
        plannerId,
        plannerTestType: plannerTypeId,
        year,
        ...(pyqFormatForApi ? { format: pyqFormatForApi } : {}),
        categoryId: categoryId || "",
      })
    );
  };

  return (
    <div className="aits_header">
      <div
        className="aits_header_left"
        onClick={handleBackClick}
        style={{ cursor: "pointer" }}
      >
        <img className="back_icon" src={images.new_backarrow} alt="backbtn" />
        {/* <div>{paperName}</div> */}
      </div>
      <div className="aits_header_center">{paperName}</div>
      {!isMistakeBook && plannerDetails?.type === "year wise" && (
        <div className="aits_header_right">
          <select
            className="pyq_dropdown"
            value={selectedPyqYear || ""}
            onChange={handleYearChange}
          >
            {pyqYears?.map((y) => (
              <option key={y.year} value={y.year}>
                {y.year}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default Header;
